import React, { Component } from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import moment from 'moment';

import { IntlProvider } from 'react-intl';

import './App.css';

import flattenMessages from './utils/i18n/intl';
import messages from './messages';
import Routes from './components/Routes';
import ErrorDisplay from './components/ErrorDisplay';
import { authUser, getUserAttributes, signOutUser } from './libs/awsLib';


class App extends Component {
  _isMounted = false;

  static propTypes = {
    history: PropTypes.object.isRequired,
    locale: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      isAuthenticated: false,
      isAuthenticating: true,
      userAttributes: {},
      locale: props.locale,
      error: undefined,
    };
  }

  componentDidMount() {
    this._isMounted = true;
    authUser()
      .then(isAuthenticated => this.userHasAuthenticated(isAuthenticated))
      .catch((e) => {
        if (e.code === 'NetworkingError') {
          this.setState({ error: e.code });
        } else {
          console.error(e);
        }
        if (this._isMounted) {
          this.setState({ isAuthenticating: false });
        }
      });
  }
  componentWillUnmount() {
    this._isMounted = false;
  }

  userHasAuthenticated = (authenticated) => {
    if (this._isMounted) {
      this.setState({ isAuthenticating: false, isAuthenticated: authenticated });
    }
    if (authenticated) {
      getUserAttributes()
        .then(userAttributes => this.setState({
          userAttributes: {
            ...userAttributes,
            isAdmin: userAttributes['cognito:groups'].indexOf('adminGroup') !== -1,
            isDriver: userAttributes['cognito:groups'].indexOf('driverGroup') !== -1,
            isPsy: userAttributes['cognito:groups'].indexOf('psyGroup') !== -1,
          },
        }));
    } else {
      if (this._isMounted) {
        this.setState({ userAttributes: {} });
      }
    }
  };

  handleLogout = () => {
    signOutUser();

    this.userHasAuthenticated(false);

    this.props.history.push('/login');
  };

  handleChangeLocale = (newLocale) => {
    localStorage.locale = newLocale;
    this.setState({ locale: newLocale });
  }


  render() {
    const { locale, isAuthenticating, error } = this.state;
    const childProps = {
      isAuthenticated: this.state.isAuthenticated,
      userHasAuthenticated: this.userHasAuthenticated,
      handleLogout: this.handleLogout,
      userAttributes: this.state.userAttributes,
      handleChangeLocale: this.handleChangeLocale,
    };
    moment.locale(locale);

    return (
      <IntlProvider locale={locale} key={locale} messages={flattenMessages(messages[locale])}>
        {isAuthenticating
          ? <div>Loading ...</div>
          : error !== undefined
          ? <ErrorDisplay error={error} />
          : <Routes childProps={childProps} />}
      </IntlProvider>
    );
  }
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/App.js